<header class="workspace-header">

        <div class="header-left">

            <!-- <div class="header-icon">
                <i class="fas fa-file-signature"></i>
            </div>

            <div>
                <h4>Calibración de firmas.</h4>
                <span>Seleccione un documento y coloque las áreas de firma.</span>
            </div> -->

        </div>

        <div class="header-right">

            <div class="autosave">

                <i class="fas fa-cloud-upload-alt"></i>

                <div>

                    <small>Autoguardado</small>

                    <strong>{{ hora }}:{{ minutos }}:{{ segundos }}</strong>

                </div>

            </div>

        </div>

    </header>

<div class="row">
    <div class="col-sm-3">
        <app-file-list [documentData]="detalleShowDocument" (fileSelected)="selectDocument($event)"></app-file-list>
    </div>
    <div class="col-sm-9">
        <app-file-viewer [url_document]="documentPdfUrl" [modulo]="'Plantilla'" [listCertificado]="plantillaCoordenadas"
            (addCertificado)="addCertificado($event)" (deleteCertificado)="deleteCoordenada($event)"></app-file-viewer>
    </div>
</div>